import React from 'react';
import RihenHero from '../components/RihenHero';
import SkillsSection from '../components/SkillsSection';
import HomeProjectsSection from '../components/HomeProjectsSection';
import HomePathSection from '../components/HomePathSection';
import CertificationsSection from '../components/CertificationsSection';
import HomeContactSection from '../components/HomeContactSection';
import journeyPatternBg from '../assets/espaces-culturel/1987.jpg';
import { mainProjects } from '../data/projects';
import { useLocale } from '../context/LocaleContext';

const Home = () => {
  const { t } = useLocale();

  return (
    <div className="rihen-site">
      <div className="rihen-grain" aria-hidden="true" />
      <RihenHero withWave />

      <SkillsSection
        id="competences"
        withTopWave
        withHomeSeam
        withChaosBackground
        sectionClassName="rihen-section rihen-section--surface rihen-section--after-seam"
        showIntroHeader
        introCentered={false}
        introEyebrow={t('skills_badge')}
        introTitle={t('skills_title_line1')}
        introTitleLine2={t('skills_title_line2')}
        introTitleClassName="hero-manifest__title hero-manifest__title--on-surface"
        introSubtitle={t('skills_subtitle')}
      />

      <HomeProjectsSection
        id="projets"
        projects={mainProjects}
        eyebrow={t('home_section_projects_badge')}
        title={t('home_section_projects_title_line1')}
        titleLine2={t('home_section_projects_title_line2')}
        subtitle={t('home_section_projects_subtitle')}
      />

      <div className="home-journey-band">
        <div
          className="home-journey-band__bg"
          style={{ backgroundImage: `url(${journeyPatternBg})` }}
          aria-hidden="true"
        />
        <div className="home-journey-band__scrim" aria-hidden="true" />

        <HomePathSection sectionClassName="rihen-section home-path-section home-journey-band__section" />

        <div className="home-journey-band__separator" aria-hidden="true">
          <div className="rihen-site-inner home-journey-band__separator-inner">
            <span className="home-journey-band__separator-line" />
            <span className="home-journey-band__separator-mark">
              <svg viewBox="0 0 32 32" focusable="false" aria-hidden="true">
                <path d="M16 3.5 28.5 16 16 28.5 3.5 16Z" />
                <circle cx="16" cy="16" r="2.25" />
              </svg>
            </span>
            <span className="home-journey-band__separator-line" />
          </div>
        </div>

        <CertificationsSection
          id="certifications"
          sectionClassName="rihen-section certifications-section home-journey-band__section"
          introEyebrow={t('certifications_badge')}
          introTitle={t('certifications_title_line1')}
          introTitleLine2={t('certifications_title_line2')}
          introSubtitle={t('certifications_subtitle')}
        />
      </div>

      <HomeContactSection />
    </div>
  );
};

export default Home;
